import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientContactEntity } from './client-contact.entity';
import { ReconSocialProfileEntity } from './recon-social-profile.entity';

/**
 * Maps social profiles to existing CRM client contacts.
 * Enables cross-platform identity resolution.
 */
@Entity('recon_contact_mapping')
@Index(
	'idx_recon_contact_mapping_unique',
	['socialProfileId', 'clientContactId'],
	{
		unique: true,
	},
)
export class ReconContactMappingEntity extends BaseEntity {
	@Column('int', { name: 'social_profile_id', unsigned: true })
	public socialProfileId!: number;

	@Column('int', { name: 'client_contact_id', unsigned: true })
	public clientContactId!: number;

	/**
	 * How the match was made.
	 * 'auto_email', 'auto_name', 'manual', 'suggested'
	 */
	@Column('varchar', { name: 'match_type', length: 30 })
	public matchType!: string;

	/**
	 * Confidence score for auto matches.
	 * 0.00 - 1.00
	 */
	@Column('decimal', {
		name: 'match_confidence',
		precision: 3,
		scale: 2,
		nullable: true,
	})
	public matchConfidence!: number | null;

	/**
	 * Whether a human has verified this match.
	 */
	@Column('tinyint', { name: 'verified', default: 0, width: 1 })
	public verified!: boolean;

	@Column('int', { name: 'verified_by', unsigned: true, nullable: true })
	public verifiedBy!: number | null;

	@Column('datetime', { name: 'verified_at', nullable: true })
	public verifiedAt!: Date | null;

	// Relations
	@ManyToOne(() => ReconSocialProfileEntity)
	@JoinColumn({ name: 'social_profile_id' })
	public socialProfile?: ReconSocialProfileEntity;

	@ManyToOne(() => ClientContactEntity)
	@JoinColumn({ name: 'client_contact_id' })
	public clientContact?: ClientContactEntity;
}
